/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'space-directory.filters.personal.v2': 'Osobní',
  'space-directory.filters.starred': 'Oblíbené',
};
